const translations = {
  fr: {
    nav: {
      services: "Services",
      espace: "Espace",
      localisation: "Localisation",
      cta: "R\u00e9server une visite",
    },
    hero: {
      address: "321, Route d'Arlon \u2014 Strassen, Luxembourg",
      title1: "Votre espace de travail",
      title2: "d'exception",
      subtitle: "Un cadre agr\u00e9able et professionnel pour d\u00e9velopper votre activit\u00e9 sereinement. Bureaux priv\u00e9s, coworking et salles de r\u00e9union au 3\u00e8me \u00e9tage d'un b\u00e2timent bien situ\u00e9.",
      ctaPrimary: "R\u00e9server une visite",
      ctaSecondary: "D\u00e9couvrir nos espaces",
    },
    marquee: ["Luxembourg", "Coworking", "Bureaux", "Strassen", "Flexibilit\u00e9", "Proximit\u00e9", "Services"],
    services: {
      label: "Nos Services",
      title: "Des espaces con\u00e7us pour votre r\u00e9ussite",
      subtitle: "Chaque service est pens\u00e9 pour offrir confort, professionnalisme et flexibilit\u00e9.",
      items: {
        "private-offices": {
          title: "Bureaux Priv\u00e9s",
          desc: "Disponibilit\u00e9 limit\u00e9e \u2014 des espaces de travail privatifs, enti\u00e8rement \u00e9quip\u00e9s et personnalisables. Contactez-nous pour v\u00e9rifier la disponibilit\u00e9.",
        },
        "coworking": {
          title: "Espace Coworking",
          desc: "Un environnement collaboratif et stimulant pour les ind\u00e9pendants, startups et professionnels en qu\u00eate de flexibilit\u00e9.",
        },
        "meeting-rooms": {
          title: "Salles de R\u00e9union",
          desc: "\u00c9quipements audiovisuels modernes, configurations flexibles et un cadre adapt\u00e9 pour vos r\u00e9unions.",
        },
        "domiciliation": {
          title: "Si\u00e8ge Social",
          desc: "Une adresse \u00e0 Strassen pour votre si\u00e8ge social, avec gestion du courrier et services administratifs.",
        },
      },
    },
    features: {
      items: ["Acc\u00e8s 24/7", "Fibre Haut D\u00e9bit", "Caf\u00e9 & Cuisine", "S\u00e9curit\u00e9 24h"],
    },
    about: {
      label: "L'Espace",
      title: "Un cadre de caract\u00e8re pour travailler autrement",
      p1: "Situ\u00e9 au 3\u00e8me \u00e9tage du 321, route d'Arlon \u00e0 Strassen, Crown Workspace Luxembourg vous accueille dans un espace fonctionnel et bien \u00e9quip\u00e9, id\u00e9al pour travailler dans de bonnes conditions.",
      p2: "Que vous soyez une startup en plein essor, un ind\u00e9pendant ou une entreprise \u00e9tablie, nos espaces flexibles s'adaptent \u00e0 vos besoins. Profitez d'un environnement de travail agr\u00e9able, d'une communaut\u00e9 dynamique et d'une bonne localisation au Luxembourg.",
      stats: [
        { num: "15", label: "Postes de travail" },
        { num: "1", label: "Grande salle de r\u00e9union" },
        { num: "24/7", label: "Acc\u00e8s flexible" },
      ],
    },
    location: {
      label: "Localisation",
      title: "Nous trouver",
      address: "321, Route d'Arlon",
      city: "L-8011 Strassen, Luxembourg",
      floor: "3\u00e8me \u00e9tage",
      phone: "+352 621 572 444",
      hours: "Lun - Ven, 9h \u2014 12h / 14h \u2014 16h",
      email: "info@eh-management.lu",
    },
    contact: {
      label: "Contact",
      title: "Commencez votre exp\u00e9rience",
      subtitle: "Remplissez le formulaire ci-dessous et notre \u00e9quipe vous contactera sous 24 heures pour organiser une visite personnalis\u00e9e de nos espaces.",
      nameLabel: "Nom complet *",
      namePlaceholder: "Jean Dupont",
      emailLabel: "Email *",
      emailPlaceholder: "jean@entreprise.com",
      phoneLabel: "T\u00e9l\u00e9phone",
      phonePlaceholder: "+352 XXX XXX",
      companyLabel: "Entreprise",
      companyPlaceholder: "Nom de l'entreprise",
      serviceLabel: "Service souhait\u00e9",
      serviceDefault: "S\u00e9lectionnez un service",
      serviceOptions: {
        "bureaux-prives": "Bureaux Priv\u00e9s",
        "coworking": "Espace Coworking",
        "salles-reunion": "Salles de R\u00e9union",
        "domiciliation": "Si\u00e8ge Social",
      },
      accountingLabel: "Avez-vous besoin de services comptables ?",
      accountingDesc: "Notre cabinet comptable partenaire, situ\u00e9 \u00e0 proximit\u00e9, peut vous accompagner dans la gestion fiscale et comptable de votre entreprise.",
      accountingOptions: {
        oui: "Oui, je suis int\u00e9ress\u00e9(e)",
        "plus-tard": "Peut-\u00eatre plus tard",
        non: "Non merci",
      },
      messageLabel: "Message *",
      messagePlaceholder: "D\u00e9crivez votre projet ou vos besoins...",
      submit: "Envoyer le message",
      sending: "Envoi en cours...",
      success: "Message envoy\u00e9 avec succ\u00e8s",
      error: "Erreur lors de l'envoi",
    },
    testimonials: {
      label: "T\u00e9moignages",
      title: "Ce que disent nos clients",
    },
    footer: {
      tagline: "Votre partenaire pour des espaces de travail d'exception au c\u0153ur du Luxembourg.",
      navTitle: "Navigation",
      addressTitle: "Adresse",
      copyright: "\u00a9 {year} Crown Workspace Luxembourg. Tous droits r\u00e9serv\u00e9s.",
      navLinks: ["Services", "Espace", "Localisation", "Contact"],
    },
  },
  en: {
    nav: {
      services: "Services",
      espace: "Space",
      localisation: "Location",
      cta: "Book a Tour",
    },
    hero: {
      address: "321, Route d'Arlon \u2014 Strassen, Luxembourg",
      title1: "Your workspace",
      title2: "of distinction",
      subtitle: "A pleasant and professional setting to grow your business with confidence. Private offices, coworking and meeting rooms on the 3rd floor of a well-located building.",
      ctaPrimary: "Book a Tour",
      ctaSecondary: "Discover our spaces",
    },
    marquee: ["Luxembourg", "Coworking", "Offices", "Strassen", "Flexibility", "Proximity", "Services"],
    services: {
      label: "Our Services",
      title: "Spaces designed for your success",
      subtitle: "Each service is designed to offer comfort, professionalism and flexibility.",
      items: {
        "private-offices": {
          title: "Private Offices",
          desc: "Limited availability \u2014 fully equipped and customizable private workspaces. Contact us to check availability.",
        },
        "coworking": {
          title: "Coworking Space",
          desc: "A collaborative and stimulating environment for freelancers, startups and professionals seeking flexibility.",
        },
        "meeting-rooms": {
          title: "Meeting Rooms",
          desc: "Modern audiovisual equipment, flexible configurations and a suitable setting for your meetings.",
        },
        "domiciliation": {
          title: "Professional Address",
          desc: "A Strassen address for your registered office, with mail management and administrative services.",
        },
      },
    },
    features: {
      items: ["24/7 Access", "High-Speed Fibre", "Coffee & Kitchen", "24h Security"],
    },
    about: {
      label: "The Space",
      title: "A place with character to work differently",
      p1: "Located on the 3rd floor of 321, route d'Arlon in Strassen, Crown Workspace Luxembourg welcomes you in a functional and well-equipped space, ideal for working in great conditions.",
      p2: "Whether you're a growing startup, a freelancer or an established company, our flexible spaces adapt to your needs. Enjoy a pleasant work environment, a dynamic community and a great location in Luxembourg.",
      stats: [
        { num: "15", label: "Workstations" },
        { num: "1", label: "Large meeting room" },
        { num: "24/7", label: "Flexible access" },
      ],
    },
    location: {
      label: "Location",
      title: "Find us",
      address: "321, Route d'Arlon",
      city: "L-8011 Strassen, Luxembourg",
      floor: "3rd floor",
      phone: "+352 621 572 444",
      hours: "Mon - Fri, 9am \u2014 12pm / 2pm \u2014 4pm",
      email: "info@eh-management.lu",
    },
    contact: {
      label: "Contact",
      title: "Start your experience",
      subtitle: "Fill out the form below and our team will contact you within 24 hours to arrange a personalised tour of our spaces.",
      nameLabel: "Full name *",
      namePlaceholder: "John Smith",
      emailLabel: "Email *",
      emailPlaceholder: "john@company.com",
      phoneLabel: "Phone",
      phonePlaceholder: "+352 XXX XXX",
      companyLabel: "Company",
      companyPlaceholder: "Company name",
      serviceLabel: "Desired service",
      serviceDefault: "Select a service",
      serviceOptions: {
        "bureaux-prives": "Private Offices",
        "coworking": "Coworking Space",
        "salles-reunion": "Meeting Rooms",
        "domiciliation": "Professional Address",
      },
      accountingLabel: "Do you need accounting services?",
      accountingDesc: "Our partner accounting firm, located nearby, can assist you with the tax and accounting management of your business.",
      accountingOptions: {
        oui: "Yes, I'm interested",
        "plus-tard": "Maybe later",
        non: "No thanks",
      },
      messageLabel: "Message *",
      messagePlaceholder: "Describe your project or needs...",
      submit: "Send message",
      sending: "Sending...",
      success: "Message sent successfully",
      error: "Error sending message",
    },
    testimonials: {
      label: "Testimonials",
      title: "What our clients say",
    },
    footer: {
      tagline: "Your partner for exceptional workspaces in the heart of Luxembourg.",
      navTitle: "Navigation",
      addressTitle: "Address",
      copyright: "\u00a9 {year} Crown Workspace Luxembourg. All rights reserved.",
      navLinks: ["Services", "Space", "Location", "Contact"],
    },
  },
};

export default translations;
